import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  loading: false,
  data: [],
  error: false,
};

export const GetEmpIdSlice = createSlice({
  name: "GetEmpId",
  initialState,
  reducers: {
    GetEmpIdStart: (state) => {
      state.loading = true;
      state.data = [];
    },
    GetEmpIdSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.error = false;
    },
    GetEmpIdFail: (state) => {
      state.loading = false;
      state.data = [];
      state.error = true;
    },
  },
});

export const {
  GetEmpIdStart,
  GetEmpIdSuccess,
  GetEmpIdFail,
} = GetEmpIdSlice.actions;

export const GetEmpIdFunc = (userId,teamId) => (dispatch) => {
    console.log(userId,teamId)
  dispatch(GetEmpIdStart());

  const url = "http://18.132.190.48:8080/api/v1/getAllUser/team";

  return axios
    .get(`${url}?userId=${userId}&teamId=${teamId}`)
    .then((res) => {
      console.log(res.data, "res at GetEmpId form page");
      dispatch(GetEmpIdSuccess(res.data));
    })
    .catch((err) => {
      console.log(err);
      dispatch(GetEmpIdFail());
    });
};

export default GetEmpIdSlice.reducer;